import React from 'react';
import type ProductsJsmConfigurationType from '@atlassian/jira-spa-apps-products-jsm-configuration/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmConfiguration = lazyForPaint<typeof ProductsJsmConfigurationType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-configuration", jiraSpaEntry: "async-products-jsm-configuration" */ '@atlassian/jira-spa-apps-products-jsm-configuration'
		),
	),
);

const AsyncProductsJsmConfiguration = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmConfiguration}
		pageId="products-jsm-configuration"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmConfiguration;
